import { PollAnswerLabelProps } from './types';

export const PollAnswerLabel = ({ pollAnswerLabel }: PollAnswerLabelProps) => (
    <div className="flex justify-center items-center rounded-full border-2 font-medium text-sm border-black h-7 min-w-7">{pollAnswerLabel}</div>
);
